export const AnswerOptionCategoryFormStages = [
  {
    title: "Answer Option Category",
    sections: [
      {
        name: "",
        fields: [
          {
            name: "g4_name",
            description: "",
            isNameField: true,
            label: "Name",
            required: true,
            type: "nvarchar",
          },
        ],
      },
    ],
  },
];
